import { Injectable } from "@angular/core";
import { IShellPopoverLinkItem } from "@common/shell/shell-popover-link-item/shell-popover-link-item";
import { Observable } from "rxjs";
import { ChatAiUiService } from "../chat-ai-ui.service";
import { ChatAiApplicationBarItemComponent } from "./chat-ai-application-bar-item.component";

@Injectable()
export class ChatAiApplicationBarItem implements IShellPopoverLinkItem {
    public readonly linkContent = {
        component: ChatAiApplicationBarItemComponent,
    };

    public readonly ordinal = 800;
    public readonly isShown$: Observable<boolean>;
    public readonly isInternal = true;

    public constructor(
        chatUiService: ChatAiUiService,
    ) {
        this.isShown$ = chatUiService.isFeatureEnabledForCurrentBreakpoint$();
    }
}
